// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-a0f4d73a] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.option[data-v-a0f4d73a] {
  display: flex;
  align-items: center;
  width: 100%;
  height: var(--height);
  cursor: inherit;
}
.option__avatar[data-v-a0f4d73a] {
  margin-right: var(--margin);
}
.option__details[data-v-a0f4d73a] {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}
.option__lineone[data-v-a0f4d73a] {
  color: var(--color-main-text);
}
.option__linetwo[data-v-a0f4d73a] {
  color: var(--color-text-maxcontrast);
}
.option__lineone[data-v-a0f4d73a], .option__linetwo[data-v-a0f4d73a] {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 1.2;
}
.option__lineone strong[data-v-a0f4d73a], .option__linetwo strong[data-v-a0f4d73a] {
  font-weight: bold;
}
.option--compact .option__lineone[data-v-a0f4d73a] {
  font-size: 14px;
}
.option--compact .option__linetwo[data-v-a0f4d73a] {
  font-size: 11px;
  line-height: 1.5;
  margin-top: -4px;
}
.option__icon[data-v-a0f4d73a] {
  width: var(--default-clickable-area);
  height: var(--default-clickable-area);
  color: var(--color-text-maxcontrast);
}
.option__icon.icon[data-v-a0f4d73a] {
  flex: 0 0 var(--default-clickable-area);
  opacity: 0.7;
  background-position: center;
  background-size: 16px;
}
.option__details[data-v-a0f4d73a], .option__lineone[data-v-a0f4d73a], .option__linetwo[data-v-a0f4d73a], .option__icon[data-v-a0f4d73a] {
  cursor: inherit;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcListItemIcon-UmX9YoH3.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,oCAAoC;AACtC;AACA;EACE,uCAAuC;EACvC,YAAY;EACZ,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-a0f4d73a] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.option[data-v-a0f4d73a] {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: var(--height);\n  cursor: inherit;\n}\n.option__avatar[data-v-a0f4d73a] {\n  margin-right: var(--margin);\n}\n.option__details[data-v-a0f4d73a] {\n  display: flex;\n  flex: 1 1;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n}\n.option__lineone[data-v-a0f4d73a] {\n  color: var(--color-main-text);\n}\n.option__linetwo[data-v-a0f4d73a] {\n  color: var(--color-text-maxcontrast);\n}\n.option__lineone[data-v-a0f4d73a], .option__linetwo[data-v-a0f4d73a] {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  line-height: 1.2;\n}\n.option__lineone strong[data-v-a0f4d73a], .option__linetwo strong[data-v-a0f4d73a] {\n  font-weight: bold;\n}\n.option--compact .option__lineone[data-v-a0f4d73a] {\n  font-size: 14px;\n}\n.option--compact .option__linetwo[data-v-a0f4d73a] {\n  font-size: 11px;\n  line-height: 1.5;\n  margin-top: -4px;\n}\n.option__icon[data-v-a0f4d73a] {\n  width: var(--default-clickable-area);\n  height: var(--default-clickable-area);\n  color: var(--color-text-maxcontrast);\n}\n.option__icon.icon[data-v-a0f4d73a] {\n  flex: 0 0 var(--default-clickable-area);\n  opacity: 0.7;\n  background-position: center;\n  background-size: 16px;\n}\n.option__details[data-v-a0f4d73a], .option__lineone[data-v-a0f4d73a], .option__linetwo[data-v-a0f4d73a], .option__icon[data-v-a0f4d73a] {\n  cursor: inherit;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
